import {Injectable} from '@angular/core';
import {BaseService} from "../../../../../base/services/base.service";
import {AuthService} from "./auth.service";
import {NotifierService} from "../../../../../base/services/notifier/notifier.service";
import {HttpClient, HttpErrorResponse} from "@angular/common/http";
import {EventBusService} from "../../../../../base/services/eventbus/event-bus.service";
import {WebAppEndpoint} from "../../../../webapp/web-app.endpoint";
import {IParams} from "../../../../../base/endpoints/iparams";
import {IPage} from "../../../../../base/models/pagination.model";
import {IUser, UserSlice} from "../models/user.model";
import {IAuth} from "../models/auth.model";

@Injectable({
  providedIn: 'root'
})
export class UserService extends BaseService {

  constructor(
    authService: AuthService,
    notifier: NotifierService,
    private http: HttpClient,
    private eventBus: EventBusService
  ) {
    super(authService, notifier)

  }

  deleteAccount(key: string): void {
    this.http.delete(WebAppEndpoint.USER.DELETE_ME())
      .subscribe(res => {
        this.eventBus.publish(key, res)
      }, (error: HttpErrorResponse) => {
        this.handleError(error, (auth: IAuth) => {
          this.deleteAccount(key)
        }, (err: HttpErrorResponse) => {
          this.eventBus.publish(this.getErrorKey(key), err)
        })
      })
  }

  searchUsers(key: string, params: IParams) {
    this.http.get<IPage<UserSlice | IUser>>(WebAppEndpoint.USER.SEARCH(params))
      .subscribe((res: IPage<UserSlice | IUser>) => {
        this.eventBus.publish(key, res)
      }, (error: HttpErrorResponse) => {
        this.handleError(error, (auth: IAuth) => {
          this.searchUsers(key, params)
        }, (err: HttpErrorResponse) => {
          this.eventBus.publish(this.getErrorKey(key), err)
        })
      })
  }

}
